export default {
  title: 'Settings',
};
